/*
 * $Id:: constants.js 2020/11/05 06:22 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

export const SLICE_NAME = 'finalizedApplications';
export const IMAGE_SLICE_NAME = 'applicationImage';
